<template>
  <JobList isMSDCustom :customCompanyId="customCompanyId"></JobList>
</template>

<script>

export default {
  components: {
    JobList: () => import('../../companyJobList.vue')
  },
  metaInfo () {
    return {
      title: '默沙东社会招聘',
      meta: [
        {
          name: 'keywords',
          content: '默沙东中国, 默沙东招聘, 默沙东职位, 职业生涯, 社会招聘'
        },
        {
          name: 'description',
          content: '加入我们，与全球默沙东员工一起为生命增辉'
        }
      ]
    }
  },
  props: {
    customCompanyId: {
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
